export default "/images/vendor/flag-icons/flags/1x1/zw.svg?6846032463fa03beeafc76aed467871e";